import React from "react";
import { CheckCircleIcon, MinesCircleIcon } from "@pd/pd-ui-kit";

export const BASE_STAFF_OPTIONS = [
  "id",
  "ladaAcademiaId",
  "fullname",
  "workPhone",
  "email",
  "dealerCenter",
  "status",
  "verifiedInDnm",
  "positions",
  "createdAt",
  "lastEditDate",
];

export interface StatusSelectOption {
  value: string;
  label: string;
  permissions?: string[];
  isDisabled?: boolean;
  icon?: React.ReactNode;
}

export const StatusSelectOptions: StatusSelectOption[] = [
  {
    value: "verified",
    label: "Проверен",
    permissions: ["employeeAccounting.employee.position.verify"],
    icon: <CheckCircleIcon size={14} fill="#00BB6D" />,
  },
  {
    value: "rejected",
    label: "Отклонен",
    permissions: ["employeeAccounting.employee.position.reject"],
    icon: <MinesCircleIcon size={14} fill="#F21B1B" />,
  },
  {
    value: "sendCheck",
    label: "Отправлен на проверку",
    isDisabled: true,
    icon: <MinesCircleIcon size={14} fill="#FF9E1B" />,
  },
  { value: "fired", label: "Уволен", isDisabled: true },
  // { value: "unverified", label: "Не проверен", isDisabled: true },
  { value: "unverified", label: "В работе у ДЦ", isDisabled: true },
  {
    value: "temporaryUnavailable",
    label: "Временно отсутствует",
    isDisabled: true,
  },
  { value: "archive", label: "Архив", isDisabled: true },
];
